import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import "./login.style.scss";

// Components Login
import { FormLogin } from "./components/FormLogin/form.view";
import { HeaderLogin } from "./components/HeaderLogin/header.view";
import { ModalInfoLogin } from "./components/ModalInfoLogin";
import { NavDrawer } from "../../components/Landing/Header/NavDrawer";

export const Login = () => {
  const { screen, id } = useParams();

  const [visualizar, setVisualizar] = useState<boolean>(true);
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);

  return (
    <div className="login-screen-container">
      <div className="login-backdrop-overlay" />

      {!drawerOpen && (
        <button
          type="button"
          className="login-top-hamburger-btn"
          title="Abrir menú"
          aria-label="Abrir menú"
          onClick={() => setDrawerOpen(true)}
        >
          <FaBars size={20} />
        </button>
      )}

      <NavDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />

      <div className="login-card-center">
        <HeaderLogin />
        <FormLogin screen={screen} id={id} />
      </div>

      <ModalInfoLogin
        visualizar={visualizar}
        setVisualizar={setVisualizar}
      />
    </div>
  );
};
